import styled from 'styled-components';
import { Typography } from '../../../global/theme';

export const HeaderBlock = styled.div`
  display: flex;
  padding: 10px 24px;
  align-items: center;
  gap: 30px;
  justify-content: space-between;
  border-bottom: 0.5px solid var(--border-primary);
  background: var(--background-secondary);
  position: sticky;
  top: 0;
  z-index: 9;
`;

export const LeftBlock = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
`;

export const ActionBlock = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  .three-dot-icon {
    padding: 5px;
    cursor: pointer;
    stroke: var(--text-secondary);
    &:hover {
      background: var(--neutral-secondary);
      border-radius: var(--border-radius-4);
    }
  }
`;

export const TitleDiv = styled.div`
  display: flex;
  padding-right: 16px;
  align-items: center;
  gap: 8px;
  p {
    ${Typography.body_lg};
    color: var(--text-secondary);
    margin: 0;
  }
`;

export const IconDiv = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px;
  cursor: pointer;
  svg {
    fill: var(--text-secondary);
  }
  :hover {
    background-color: var(--neutral-secondary);
    border-radius: var(--border-radius-4);
    svg {
      fill: var(--text-primary);
    }
  }
`;

export const Empty = styled.div`
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
`;
